/**
 * Stories implemented
 */
/* eslint-disable local-rules/require-storybook-documentation */
import type { FunctionComponent } from 'react';
import { Paragraph } from '@zillow/constellation-10';
import { HumanReadableHelpHotline } from 'src/common/constants';
import { PhoneLink } from 'src/components/Typography/PhoneLink';
import { getPhoneNumber } from 'src/components/Typography/PhoneLink/utils/getPhoneNumber';
import { ErrorPage } from '../../../components/ErrorPage';

export const PageCannotLoad: FunctionComponent = () => (
    <ErrorPage
        headingText="Something went wrong"
        subHeadingText={
            <Paragraph>
                Please refresh the page to try again. If the issue continues or you have questions about your loan
                application, call us at <PhoneLink {...getPhoneNumber(HumanReadableHelpHotline.CUSTOMER_EXPERIENCE)} />.
            </Paragraph>
        }
    />
);
